import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useEverifyUpdateCompany() {
  return useMutation({
    mutationFn: async (companies) => {
      const { data } = await api.put("/everifycompany/updatecompany", companies);
      return data;
    },
  });
}
